// targetsApi.js

import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import { URLAPI } from "../../configuration";

const rawBaseQuery = fetchBaseQuery({
    baseUrl: URLAPI,
    prepareHeaders: (h, { getState }) => {
        const token = getState().auth.user.jwt;
        if (token) h.set("Authorization", `Bearer ${token}`);
        return h;
    },
});

const baseQuery = retry(rawBaseQuery, {
    maxRetries: 5,
});

export const targetsApi = createApi({
    reducerPath: "targetsApi",
    baseQuery,
    tagTypes: ["Targets"],
    endpoints: (builder) => ({
        getTargets: builder.query({
            query: (hotelID) => ({
                url: "/manual_targets",
                method: "GET",
                params: {
                    hotel_id: hotelID,
                },
            }),
            providesTags: (result, error, hotelID) => [
                { type: "Targets", id: hotelID },
            ],
            keepUnusedDataFor: 60 * 30,
        }),
    }),
});

export const { useGetTargetsQuery } = targetsApi;
